import Vue from 'vue'
import localeLoader from '../../util/locale'
import VueLogger from 'vuejs-logger'

let version = process.env.QPKG_VER
let build = process.env.BUILD_TIME

const isProduction = process.env.NODE_ENV === 'production'
const options = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
}
Vue.use(VueLogger, options)

const state = {
  intervalTime: '3000',
  lang: '',
  isAutoDetect: false,
  sidebarCollapsed: false,
  sidebarItemCollapsed: false,
  selectMenu: {
    'title': 'menu.dashboard',
    'path': 'dashboard'
  },
  subMenu: null,
  about: {
    'version': version,
    'build': build
  },
  showAbout: false,
  showHelper: false,
  isDataChanged: false,
  nextMenu: null,
  isSidebar: null,
  updateStatus: null,
  showInfoTips: false,
  showQuickHelp: false,
  infoObj: null,
  deviceCollapsed: false,
  getDeviceData: false,
  loadingType: '',
  showToast: false
}

const module = {
  state,
  mutations: {
    updateLang (state, { lang }) {
      state.lang = lang
    },
    updateAutoDetect (state, status) {
      state.isAutoDetect = status
    },
    setSidebarItemCollapsed (state, collapsed) {
      state.sidebarItemCollapsed = collapsed
    },
    setSidebarCollapsed (state, collapsed) {
      state.sidebarCollapsed = collapsed
    },
    updateMenu (state, menu) {
      state.selectMenu = menu
    },
    updateSubMenu (state, menu) {
      state.subMenu = menu
    },
    openAbout (state) {
      state.showAbout = true
    },
    closeAbout (state) {
      state.showAbout = false
    },
    openHelper (state) {
      state.showHelper = true
    },
    closeHelper (state) {
      state.showHelper = false
    },
    updateDataChanged (state, change) {
      state.isDataChanged = change
    },
    updateNextMenu (state, menu) {
      state.nextMenu = menu
      Vue.$log.debug(menu)
    },
    updateIsSidebar (state, sidebar) {
      state.isSidebar = sidebar
    },
    updateFwStatus (state, update) {
      state.updateStatus = update
    },
    updateInfoTips (state, infoTips) {
      state.showInfoTips = infoTips
    },
    updateInfoData (state, data) {
      state.infoObj = data
    },
    updateQuickHelp (state, show) {
      state.showQuickHelp = show
    },
    updatedeviceCollapsed (state, status) {
      state.deviceCollapsed = status
    },
    updateGetDeviceData (state, status) {
      state.getDeviceData = status
    },
    setLoadingType (state, type) {
      state.loadingType = type
    },
    updateToast (state, status) {
      state.showToast = status
    }
  },
  actions: {
    loadLocale (context, lang) {
      context.commit('updateLang', lang)
      Vue.cookie.set('QSW_LANG', lang.lang, { expires: '1M' })
      return new Promise(async (resolve, reject) => {
        localeLoader(state.lang).then(locale => {
          Vue.config.lang = state.lang
          Vue.locale(state.lang, locale.default)
          resolve(locale)
        })
      })
    }
  }
}
export default module



// WEBPACK FOOTER //
// ./src/store/app/common.js